export interface HrDocumentType {
  documentTypeId?: number;
  owningCompanyId?: number;
  documentCode?: string;
  documentName?: string;
  appliesToWorkerCategory?: string;
  countryCode?: string;
  requiredDocument?: boolean;
  requiresNumber?: boolean;
  requiresIssueDate?: boolean;
  requiresExpiryDate?: boolean;
  requiresFile?: boolean;
  requiresVerification?: boolean;
  blocksDispatch?: boolean;
  blocksMobilization?: boolean;
  blocksPayroll?: boolean;
  blocksOnboardingCompletion?: boolean;
  expiryWarningDays?: number;
  confidentialityLevel?: string;
  systemDefault?: boolean;
  active?: boolean;
  description?: string;
}

export interface HrEmployeeDocument {
  documentId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  documentTypeId?: number;
  documentCode?: string;
  documentName?: string;
  documentNumber?: string;
  issuer?: string;
  countryCode?: string;
  issueDate?: string;
  expiryDate?: string;
  fileUrl?: string;
  fileName?: string;
  fileContentType?: string;
  verificationStatus?: string;
  complianceStatus?: string;
  verifiedByCustomerId?: number;
  verifiedAt?: string;
  rejectionReason?: string;
  confidentialityLevel?: string;
  sourceModule?: string;
  sourceResourceId?: number;
  migrationSource?: string;
  active?: boolean;
  notes?: string;
  lastEvaluatedAt?: string;
  lastAlertedAt?: string;
  productivityTaskId?: number;
  productivityNotificationId?: number;
  createdAt?: string;
  updatedAt?: string;
  verificationEvents?: HrDocumentVerificationEvent[];
}

export interface HrEmployeeDocumentFilters {
  owningCompanyId?: number;
  employeeId?: number;
  documentTypeId?: number;
  workerCategory?: string;
  complianceStatus?: string;
  verificationStatus?: string;
  active?: boolean;
  page?: number;
  pageSize?: number;
}

export interface HrDocumentVerificationEvent {
  verificationEventId?: number;
  documentId?: number;
  employeeId?: number;
  eventType?: string;
  oldStatus?: string;
  newStatus?: string;
  reason?: string;
  eventByCustomerId?: number;
  eventAt?: string;
}

export interface HrDocumentComplianceRow {
  snapshotId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  documentTypeId?: number;
  documentId?: number;
  documentCode?: string;
  documentName?: string;
  requiredDocument?: boolean;
  verificationStatus?: string;
  expiryStatus?: string;
  expiryDate?: string;
  daysUntilExpiry?: number;
  blocksDispatch?: boolean;
  blocksMobilization?: boolean;
  blocksPayroll?: boolean;
  blocksOnboardingCompletion?: boolean;
  confidentialityLevel?: string;
  sourceModule?: string;
  generatedAt?: string;
}

export interface HrDocumentCenterSummary {
  owningCompanyId?: number;
  totalRows?: number;
  validDocuments?: number;
  expiringSoon?: number;
  expired?: number;
  missingRequired?: number;
  pendingVerification?: number;
  rejected?: number;
  waived?: number;
  evaluatedAt?: string;
}

export interface HrDocumentCenter {
  summary?: HrDocumentCenterSummary;
  rows?: HrDocumentComplianceRow[];
}

export interface HrDocumentEvaluationResult {
  owningCompanyId?: number;
  employeesEvaluated?: number;
  documentsEvaluated?: number;
  snapshotsCreated?: number;
  tasksCreated?: number;
  notificationsCreated?: number;
  evaluatedAt?: string;
}

export const HR_DOCUMENT_STATUSES = ['MISSING', 'PENDING_VERIFICATION', 'VALID', 'EXPIRING_SOON', 'EXPIRED', 'REJECTED', 'WAIVED'];

export const HR_DOCUMENT_VERIFICATION_STATUSES = ['PENDING', 'VERIFIED', 'REJECTED', 'EXPIRED', 'WAIVED'];

export const HR_DOCUMENT_CONFIDENTIALITY_LEVELS = ['PUBLIC', 'INTERNAL', 'HR_RESTRICTED', 'PAYROLL_RESTRICTED', 'MEDICAL_RESTRICTED', 'LEGAL_RESTRICTED'];

